"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classNames = require("classnames");

var React = require("react");

var getTextChildren_1 = require("../assets/getTextChildren");

var withStyles_1 = require("../decorators/withStyles");

var Icon_1 = require("../Icon/Icon");

var Progress_1 = require("../Progress/Progress");

var Button_styles_1 = require("./Button.styles");

var withResponsive_1 = require("../decorators/withResponsive");

var baseProps_1 = require("../assets/baseProps");

var Button =
/** @class */
function (_super) {
  __extends(Button, _super);

  function Button() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Button.prototype.render = function () {
    var _a, _b, _c, _d;

    var props = this.props;
    var _e = props.type,
        type = _e === void 0 ? 'button' : _e,
        _f = props.responsive,
        responsive = _f === void 0 ? 'auto' : _f,
        progress = props.progress,
        progressText = props.progressText,
        primary = props.primary,
        warning = props.warning,
        danger = props.danger,
        icon = props.icon,
        iconAfter = props.iconAfter,
        classes = props.classes,
        disabled = props.disabled,
        fluid = props.fluid,
        large = props.large,
        small = props.small,
        flat = props.flat,
        contrast = props.contrast,
        dangerouslyApplyFocusStyle = props.dangerouslyApplyFocusStyle,
        dangerouslyApplyHoverStyle = props.dangerouslyApplyHoverStyle,
        dangerouslyApplyActiveStyle = props.dangerouslyApplyActiveStyle,
        dangerouslyStopAnimation = props.dangerouslyStopAnimation;
    var textChildren = getTextChildren_1.default(props);
    var className = classNames(classes.base, (_a = {}, _a[classes.primary] = primary, _a[classes.warning] = warning, _a[classes.danger] = danger, _a[classes.fluid] = fluid, _a[classes.large] = large, _a[classes.small] = small, _a[classes.flat] = flat, _a[classes.contrast] = contrast, _a[classes.disabled] = disabled, _a[classes.progressWrapper] = progress, _a[classes.mobile] = responsive === 'mobile', _a[classes.auto] = responsive === 'auto', _a[classes.icon] = !!icon && !textChildren || !!iconAfter && !textChildren, _a[classes.focus] = dangerouslyApplyFocusStyle, _a[classes.hover] = dangerouslyApplyHoverStyle, _a[classes.active] = dangerouslyApplyActiveStyle, _a));
    return React.createElement("button", __assign({}, baseProps_1.default(props), {
      className: className,
      disabled: disabled,
      type: type
    }), icon && React.createElement("div", {
      className: classNames(classes.inner, classes.innerIcon, (_b = {}, _b[classes.iconWithText] = !!icon && !!textChildren, _b))
    }, React.createElement(Icon_1.default, {
      icon: icon
    })), (progress || progressText) && React.createElement("div", {
      className: classNames(classes.inner, (_c = {}, _c[classes.progress] = progress, _c[classes.progressText] = progressText, _c))
    }, React.createElement(Progress_1.default, {
      accent: primary,
      size: progress ? 20 : 16,
      dangerouslyStopAnimation: dangerouslyStopAnimation
    })), React.createElement("span", {
      className: classNames(classes.innerText, classes.inner),
      style: {
        visibility: progress ? 'hidden' : 'visible'
      }
    }, textChildren), iconAfter && React.createElement("div", {
      className: classNames(classes.inner, classes.innerIcon, (_d = {}, _d[classes.iconWithTextBefore] = !!iconAfter && !!textChildren, _d))
    }, React.createElement(Icon_1.default, {
      icon: iconAfter
    })));
  };

  Button = __decorate([withResponsive_1.withResponsive, withStyles_1.withStyles(Button_styles_1.styles)], Button);
  return Button;
}(React.PureComponent);

exports.default = Button;